module.exports = __webpack_public_path__ + "static/media/4.fd33c10d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/4.png
// module id = 1724
// module chunks = 0